import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { NgxMonacoEditorConfig, MonacoEditorModule } from "ngx-monaco-editor-v2";
import { MonacoTheme } from "./monaco-theme";

import { JsonInputComponent } from './json-input.component';
import { HtmlInputComponent } from './html-input.component';

import MoteDefinitionsScheme from "@motes-schema/mote.data.schema.json"
import StatEventDefinitionsScheme from "@motes-schema/stat-event.schema.json"
import MoteEventTypeDefinitionsScheme from "@motes-schema/mote-event-type.schema.json"
import TourInfoTypeDefinitionsScheme from "@motes-schema/tour-info.schema.json"
import { MotesPaths } from "../../models/motes-paths";

const MoteDefinitions = MoteDefinitionsScheme.definitions;
const StatEventDefinitions = StatEventDefinitionsScheme.definitions;
const MoteEventTypeDefinitions = MoteEventTypeDefinitionsScheme.definitions;
const TourInfoTypeDefinitions = TourInfoTypeDefinitionsScheme.definitions;

//
// OBS: Remember to insert 
// { "glob": "**/*", "input": "node_modules/ngx-monaco-editor/assets/monaco", "output": "./assets/monaco/" }
// in angular.json

export { NgxEditorModel } from "ngx-monaco-editor-v2";
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';

interface CustomWindow extends Window {
    monaco?: typeof monaco;
}
declare let window: CustomWindow;

// JSON / JS Editor configuration 
let monacoConfig: NgxMonacoEditorConfig = {
    defaultOptions: {
        scrollBeyondLastLine: false,
        minimap: {
            enabled: false
        }
    },
    // pass default options to be used
    onMonacoLoad: monacoLoad
};

function generateSchema(definitions: any, modelName: string) {
    // Ensure there are no circular refs by copying model
    let model = Object.assign({}, definitions[modelName]);
    // Add other definitions to definition
    model['definitions'] = definitions;
    return model;
}

export function monacoLoad() {
    const monaco = window?.monaco;
    if(!monaco) return console.warn("Could not load monaco editor");

    monaco.editor.defineTheme('myTheme', MonacoTheme.json);
    monaco.editor.setTheme('myTheme');
    monaco.languages.typescript.javascriptDefaults.setDiagnosticsOptions({
        noSemanticValidation: true,
        noSyntaxValidation: false
    });

    // compiler options
    monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
        target: monaco.languages.typescript.ScriptTarget.ES2016,
        allowNonTsExtensions: true,
        allowJs: true,
    });

    monaco.languages.typescript.typescriptDefaults.setDiagnosticsOptions({
        noSemanticValidation: false,
        noSyntaxValidation: false
    });

    monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
        validate: true,
        schemas: [{
            uri: MotesPaths.MOTES_REST + '/stat-event.schema.json',
            fileMatch: ['motes://stat-event.json'],
            schema: generateSchema(StatEventDefinitions, "StatEvent")
        },
        {
            uri: MotesPaths.MOTES_REST + '/mote.schema.json',
            fileMatch: ['motes://mote.json'],
            schema: generateSchema(MoteDefinitions, "MoteData")
        },
        {
            uri: MotesPaths.MOTES_REST + '/mote-event-type.schema.json',
            fileMatch: ['motes://media-event-map.json'],
            schema: generateSchema(MoteEventTypeDefinitions, "MediaEventMap")
        },
        {
            uri: MotesPaths.MOTES_REST + '/tour-info.schema.json',
            fileMatch: ['motes://tour-info.json'],
            schema: generateSchema(TourInfoTypeDefinitions, "TourInfo")
        }]
    });
}

@NgModule({
    declarations: [
        JsonInputComponent,
        HtmlInputComponent
    ],
    imports: [
        MonacoEditorModule.forRoot(monacoConfig),
        CommonModule,
        FormsModule
    ],
    exports: [
        MonacoEditorModule,
        JsonInputComponent,
        HtmlInputComponent
    ]
})
export class CodeEditorModule { }
